export const AirSwitcherStyle = Object.freeze({
	SOLID: 'SOLID',
	TINTED: 'TINTED',
});
